"use strict";

define('controller/legacy.upload',['require','exports','module','underscore','marionette','../config','./base','../model/base','../model/upload','../view/legacy.upload','langs'],function (require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var config = require('../config');
  var RegionController = require('./base');
  var BaseModel = require('../model/base');
  var UploadModel = require('../model/upload');
  var LegacyUploadView = require('../view/legacy.upload');
  var langs = require('langs');
  var LEGACY_ROOT_URI = '/rs/api/form/study/legacy';
  var LegacyUploadController = RegionController.extend({
    header: langs.phrase('App.Title'),
    onBeforeStart: function onBeforeStart() {
      if (this.app.user.userName != 'cayuseadmin') {
        throw new Error('You have insufficient permissions to access this page.');
      }
    },
    onStart: function onStart() {
      var view = new LegacyUploadView({
        app: this.app,
        pageTitle: langs.phrase('LegacyUpload.Title'),
        resultsTitle: langs.phrase('LegacyUpload.Results.Title')
      });
      view.$el.css(config.contentCss);
      this.listenTo(view, 'file:choose', function () {
        this.app.request('file:chooser', {
          accept: ['.csv'],
          events: false,
          callback: function callback(files) {
            if (files.length > 0) {
              view.triggerMethod('file:selected', files[0]);
            }
          }
        });
      }).listenTo(view, 'file:validate', function (file) {
        var url = LEGACY_ROOT_URI + '/validate',
          uploads = UploadModel.createCollection(url, [file], BaseModel);
        uploads.on('upload:complete', function (uploadModel, genericCollection) {
          view.triggerMethod('file:validated', genericCollection.models[0]);
        });
        this.app.request('file:upload', uploads);
      }).listenTo(view, 'file:submit', function (file) {
        var url = LEGACY_ROOT_URI,
          uploads = UploadModel.createCollection(url, [file], BaseModel);
        uploads.on('upload:complete', function () {
          view.triggerMethod('file:imported');
        });
        this.app.request('file:upload', uploads);
      });
      this.state.addPageDependencies([]);
      this.region.show(view);
    }
  });
  module.exports = LegacyUploadController;
});

